export const LibraryIcon = ({ size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    {/* Left book — filled */}
    <rect x="4" y="6" width="4" height="13" rx="0.5" fill="#857f7f" />
    <path d="M4 6 L5 5 L9 5 L8 6 Z" fill="#a09a9a" />
    <path d="M8 6 L9 5 L9 18 L8 19 Z" fill="#605c5c" />

    {/* Right book — leaning against middle (drawn first so middle covers the contact point) */}
    <g transform="rotate(-12 16 19)">
      <rect x="16" y="6" width="4" height="13" rx="0.5" fill="#857f7f" />
      <path d="M16 6 L17 5 L21 5 L20 6 Z" fill="#a09a9a" />
      <path d="M20 6 L21 5 L21 18 L20 19 Z" fill="#605c5c" />
    </g>

    {/* Middle book — pulled forward, highlighted (drawn LAST so it sits in front) */}
    <rect x="9" y="4" width="4" height="16" rx="0.5" fill="#7aabd4" />
    <path d="M9 4 L10 3 L14 3 L13 4 Z" fill="#a8caea" />
    <path d="M13 4 L14 3 L14 19 L13 20 Z" fill="#5588b5" />
  </svg>
);
